<!-- 种类列表    background-color="#2c3e50"-->
<template>
  <div class="nav">
    <div class="logo">
      <img src="@/image/logo.png" alt srcset v-if="!isCollapse" style="width: 30px;" />
      <img src="@/image/logo.png" alt srcset v-else style="width: 45px;" />
      <div v-if="!isCollapse" class="title">简古香铺管理系统</div>
    </div>
    <!--
       TODO:
      hide可继续优化到store中去做映射，映射出2组数据，一组为权限设置全量的导航数据，一组为导航实际展示数据
      或 item.children.filter((j)=>{console.log(j); return j.hide}
    -->
    <el-menu
      :default-active="active"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      :unique-opened="true"
      background-color="#2c3e50"
      text-color="#fff"
      active-text-color="#ffcd4d"
    >
      <template v-for="item in navData">
        <!-- 一级导航 -->
        <el-menu-item
          :index="item.id"
          v-if="!item.children && !item.hide"
          :key="item.id"
          @click="itemBtn(item)"
        >
          <i :class="item.icon"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
        <!-- 存在二级的一级导航 -->
        <el-submenu :index="item.id" :key="item.id + 1" v-if="item.children && !item.hide">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.label }}</span>
          </template>
          <!-- 二级 -->
          <div v-for="(item_next, index_next) in item.children" :key="index_next">
            <el-menu-item
              :index="item_next.id"
              v-if="!item_next.children && !item_next.hide"
              @click="itemBtn(item_next)"
            >
              <span slot="title">{{ item_next.label }}</span>
            </el-menu-item>
            <!-- 存在三级的二级导航 -->
            <el-submenu :index="item_next.id" v-if="item_next.children && !item_next.hide">
              <span slot="title">{{ item_next.label }}</span>
              <!-- 三级 -->
              <template v-if="!item_next.hide">
                <el-menu-item
                  v-for="(item_next_next, index_next_next) in item_next.children"
                  :key="index_next_next"
                  :index="item_next_next.id"
                  @click="itemBtn(item_next_next)"
                >{{ item_next_next.label }}</el-menu-item>
              </template>
            </el-submenu>
          </div>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "Nav",
  components: {},
  props: {
    isCollapse: {
      type: Boolean,
      default: true
    },
    navData: {
      type: Array
    },
    active: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    itemBtn(item, index) {
      this.$emit("clickNav", item, index);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    }
  }
};
</script>

<style scoped lang="less">
.nav {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background: #2c3e50;

  .logo {
    background: linear-gradient(to right, #12c2e9, #71ed7d);
    // background: linear-gradient(to bottom right, #1d3b45, #0a1b37);
    // background: #174b83;
    display: flex;
    align-items: center;
    color: #ffffff;
    font-weight: 550;
    justify-content: center;
    font-size: 14px;
    letter-spacing: 2px;
    height: 50px;

    img {
      width: 50px;
    }

    .title {
      margin-left: 10px;
    }
  }
}

// .el-menu-vertical-demo:not(.el-menu--collapse) {
//   width: 200px;
//   min-height: 400px;
// }
/* 菜单选中后的颜色 */
.el-menu .el-menu-item.is-active {
  background-color: #5e738b !important;
}

/* 点击二级菜单时多出的一像素边框问题 */
.el-menu {
  border-right: none;
}

/* 子菜单hover颜色处理 */
// .el-menu-item:hover{
//    background-color: #11dadd !important;
// }
</style>
